import React from 'react';

interface LogoProps {
  className?: string;
  size?: number;
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 40 }) => {
  return (
    <div
      className={`relative flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <svg
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full drop-shadow-xl"
      >
        <defs>
          <linearGradient id="brand-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#06B6D4" />
            <stop offset="100%" stopColor="#0891B2" />
          </linearGradient>
          <filter id="logo-shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="1.5" />
            <feOffset dx="0" dy="1" result="offsetblur" />
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.3" />
            </feComponentTransfer>
            <feMerge>
              <feMergeNode />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* Interlocking geometric ring design */}
        <g transform="translate(50,50)" filter="url(#logo-shadow)">
          {[0, 60, 120, 180, 240, 300].map((angle, i) => (
            <g key={angle} transform={`rotate(${angle})`}>
              {/* Main geometric bar */}
              <path
                d="M-4,-32 L6,-32 C12,-32 18,-26 18,-20 L18,2 L6,2 L6,-22 L-4,-22 Z"
                fill={i % 2 === 0 ? 'white' : 'url(#brand-gradient)'}
                className="transition-all duration-700"
              />
              {/* Connector node */}
              <circle cx="18" cy="-20" r="4.5" fill={i % 2 === 0 ? 'white' : '#06B6D4'} />
            </g>
          ))}
        </g>
      </svg>
    </div>
  );
};

export default Logo;
